import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NarrativeStep from 'components/NarrativeStep';
import Loading from 'components/LoadingComponent';

class Step extends Component {
  componentDidMount() {
    const {
      match: { params: { idn, ids } },
      getSpecificStep,
    } = this.props;

    getSpecificStep(idn, ids);
  }

  render() {
    const { specificStep, actualContext } = this.props;

    if (!specificStep || !actualContext) {
      return (<Loading colorAnimation='#ffffff' />);
    }

    return (
      <NarrativeStep data={specificStep} />
    );
  }
}

Step.propTypes = {
  specificStep: PropTypes.object,
  actualContext: PropTypes.object,
  getSpecificStep: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
};

Step.defaultProps = {
  specificStep: null,
  actualContext: null,
};

export default Step;



// WEBPACK FOOTER //
// ./src/routes/Step/components/index.jsx